import { useEffect, useMemo, useState } from 'react'
import { RouterProvider } from 'react-router-dom'
import { getRouter } from '@/routes'
import { useAuthStore } from '@/store/authStore'
import { setupInterceptors } from '@/api/client'

/**
 * App is the application's startup sequence.
 *
 * Keep this file as a high-level overview: every boot step should be a single,
 * well-named call whose implementation lives elsewhere (stores, api, hooks).
 * That way the order things happen on startup is readable at a glance, and
 * adding/removing a step is a one-line change here.
 */
function App() {
  const [isBooting, setIsBooting] = useState(true)
  const user = useAuthStore((state) => state.user)
  const restoreSession = useAuthStore((state) => state.restoreSession)

  useEffect(() => {
    async function startup() {
      try {
        // --- Startup sequence (runs once, in order) ---
        setupInterceptors(() => {
          if (useAuthStore.getState().user !== null) {
            void useAuthStore.getState().logout()
          }
        })

        await restoreSession()
        // await loadFeatureFlags()
        // await initAnalytics()
        // ----------------------------------------------
      } finally {
        setIsBooting(false)
      }
    }

    void startup()
  }, [restoreSession])

  const router = useMemo(() => getRouter(user), [user])

  if (isBooting) {
    // Replace with a loading state component (logo + spinner?)
    return <p>Loading...</p>
  }

  // The router shown depends on whether a user is signed in.

  return (
    <RouterProvider
      key={user ? 'auth' : 'guest'}
      router={router}
    />
  )
}

export default App
